import { Graphics } from 'pixi.js';
import type { World, ComponentStore } from '@ecs/world';
import type { CameraResource, PlatformComponent } from '@game/scenes/characterPrototype/types';

export type PlatformSpawnStyle = {
	cornerRadius: number;
	fillColor: number;
	fillAlpha: number;
	strokeColor: number;
	strokeAlpha: number;
	strokeWidth: number;
};

export function createSpawnPlatform(style: PlatformSpawnStyle) {
	return function spawnPlatform(
		world: World,
		platforms: ComponentStore<PlatformComponent>,
		graphics: ComponentStore<Graphics>,
		stage: import('pixi.js').Application['stage'],
		x: number,
		y: number,
		width: number,
		height: number
	) {
		const entity = world.createEntity();
		platforms.set(entity, { x, y, width, height });
		const camera = world.getResource<CameraResource>('camera');
		const offsetY = camera ? camera.y : 0;
		const graphic = new Graphics();
		graphic.roundRect(0, 0, width, height, style.cornerRadius);
		graphic.fill({ color: style.fillColor, alpha: style.fillAlpha });
		graphic.stroke({ color: style.strokeColor, alpha: style.strokeAlpha, width: style.strokeWidth });
		graphic.position.set(x, y - offsetY);
		stage.addChild(graphic);
		graphics.set(entity, graphic);
		return entity;
	};
}


